import { VehicleType } from '../../codegen/vehicles';
import { VehicleIcon } from '../icons/VehicleIcon';
import { CustomFormattedMessage } from '../../i18n/i18n';

type VehicleRepresentationProps = {
  vehicleType?: VehicleType;
  vehicleName?: string;
};

export const VehicleRepresentation = ({
  vehicleType,
  vehicleName,
}: VehicleRepresentationProps) => {
  return (
    <div className="display-flex gap-5 align-items-center">
      <VehicleIcon
        type={vehicleType ?? VehicleType.Truck}
        className="text-size-18 text-color-dark"
      />
      <span className="ellipsis-1">
        {vehicleName ?? (
          <CustomFormattedMessage id={'common.vehicle.unknown'} />
        )}
      </span>
    </div>
  );
};
